export default __webpack_public_path__ + "static/media/scan-panda-landing-banner.bfd80030.png";